import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CrewCardComponent } from './crew-card/crew-card.component';
import { AngularMaterialModule } from '@shared/modules/angular-material.module';
import { SharedModule } from '@shared/modules/shared.module';
import { CrewTableComponent } from './crew-card/crew-table/crew-table.component';
import { CrewHistoryComponent } from './crew-history/crew-history.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [CrewCardComponent, CrewTableComponent, CrewHistoryComponent],
  imports: [
    CommonModule,
    AngularMaterialModule,
    SharedModule,
    ReactiveFormsModule,
  ],
  exports: [CrewCardComponent, CrewTableComponent, CrewHistoryComponent],
})
export class CrewModule {}
